export const ExampleItemInLearn = {
  extends: 'LibraryItemInLearn',
  href: null,
  onClick: (ev, el) => {
    el.setWindow('docs', '/examples')
  },
  state: {
    poster: 'example_clock.png',
    descr: 'learn.example.counter.descr',
    title: 'learn.example.counter.title'
  },
  Box: {
    position: 'relative',
    width: 'E',
    // Fill-contrast frame (was a `line`-bordered outline — border-habit
    // sweep, design-direction.md §8) around the poster thumbnail.
    background: 'overlay',
    round: 'radiusControl',
    Img: {
      display: 'block',
      round: 'radiusControl',
      position: 'relative',
      width: '100%',
      src: '{{ poster }}'
    }
  },
  Flex: {
    Strong: {},
    Span: {
      text: (el, s) => el.call('polyglot', s.descr || '')
    },
    Span_2: null
  }
}
